import { render, staticRenderFns } from "./AppEchartStackedArea.vue?vue&type=template&id=01651bf2&"
import script from "./AppEchartStackedArea.vue?vue&type=script&lang=js&"
export * from "./AppEchartStackedArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports